import queryString from "query-string";
import extend from "lodash/extend";

export function appendQueryParams(url, query) {
    const urlParts = url.split("?");
    const newQueryParams = typeof query == "string" ? queryString.parse(query) : query;
    if (urlParts.length == 2) {
        const existingQueryParams = queryString.parse(urlParts[1]);
        return urlParts[0] + "?" + queryString.stringify(extend({}, existingQueryParams, newQueryParams));
    } else if (urlParts.length == 1) {
        return urlParts[0] + "?" + queryString.stringify(newQueryParams);
    } else {
        throw new Error("Invalid URL");
    }
}
